import type { Tables, TablesUpdate } from "@/integrations/supabase/types";
import type { ServiceContext } from "@prolarus/shared";
import { tryGet, tryUpdate } from "./_shared";

export type Company = Tables<"companies">;
export type CompanyUpdate = TablesUpdate<"companies">;

type CompanyWithAudit = Company & {
  created_by_profile?: { full_name: string | null } | null;
  updated_by_profile?: { full_name: string | null } | null;
};

export const companyService = {
  get(id: string) {
    return tryGet<Company>(`/api/companies/${encodeURIComponent(id)}`);
  },

  async getDisplayName(id: string) {
    const result = await tryGet<string | null>(
      `/api/companies/${encodeURIComponent(id)}/display-name`,
    );
    return result;
  },

  getWithAuditInfo(id: string) {
    return tryGet<CompanyWithAudit>(
      `/api/companies/${encodeURIComponent(id)}?withAudit=true`,
    );
  },

  update(
    id: string,
    data: CompanyUpdate,
    _snapshot: Record<string, unknown>,
    _context: ServiceContext,
  ) {
    return tryUpdate<Company>(`/api/companies/${encodeURIComponent(id)}`, data);
  },
};
